import { render } from "./PropertyDetails.vue?vue&type=template&id=8d936a7e&scoped=true&ts=true"
import script from "./PropertyDetails.vue?vue&type=script&lang=ts"
export * from "./PropertyDetails.vue?vue&type=script&lang=ts"

import "./PropertyDetails.vue?vue&type=style&index=0&id=8d936a7e&scoped=true&lang=scss"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d936a7e"]])

export default __exports__